module.exports = __webpack_public_path__ + "img/reward_800.eff78f5f.png";